import React, { useContext } from "react";
import ChecklistSectionForm from "../checklistsection/ChecklistSectionForm";
import { ModalContext } from "../../context/ModalContext";
import ChecklistsRevisions from "./ChecklistRevisions";
import useChecklists from "../../hooks/useChecklists";
import { isCoordinador } from "../../utils/permisos";
import { itemStatus } from "../../utils/checklists";
import useProyecto from "../../hooks/useProyecto";

const ChecklistHeader = () => {
  const { idProyecto, proyecto } = useProyecto();
  const { clearModal, modalComponent } = useContext(ModalContext);
  const {
    mode,
    query,
    estado,
    setQuery,
    expandAll,
    setEstado,
    idChecklist,
    setExpandAll,
  } = useChecklists();

  const activeFilter = itemStatus.find((s) => s.value === estado) || itemStatus[0];

  const handleCreateSection = () => {
    modalComponent(
      "Agregar Sección",
      <ChecklistSectionForm
        idProyecto={idProyecto}
        idChecklist={idChecklist}
        handleCancel={clearModal}
      />
    );
  };

  const renderAddSectionBtn = () => {
    if (isCoordinador(proyecto)) {
      return (
        <button onClick={handleCreateSection} className="btn btn-primary">
          <i className="fa fa-plus"></i>
        </button>
      );
    }
  };

  const renderRevisionesDropdown = () => {
    if (mode === "check") {
      return (
        <div className="col-6">
          <ChecklistsRevisions idChecklist={idChecklist} />
        </div>
      );
    }
  };

  return (
    <div className="row align-items-center mb-3 px-0 g-2">
      <div className="col-12 col-md-8">
        <div className="row g-2 align-items-center">
          <div className="col-auto">
            <button
              onClick={() => setExpandAll(!expandAll)}
              className="btn btn-primary"
              title={expandAll ? "Contraer todo" : "Expandir todo"}
            >
              <i className={`fa fa-chevron-${expandAll ? "up" : "down"}`}></i>
            </button>
          </div>
          <div className="col">
            <input
              type="text"
              value={query}
              className="form-control"
              placeholder="Buscar sección o item"
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
          <div className="col-auto px-0">
            {renderAddSectionBtn()}
          </div>
        </div>
      </div>

      <div className="col-12 col-md-4 px-0">
        <div className="row g-2">
          <div className={`${mode === "check" ? "col-6" : "col-12"}`}>
            <div className="dropdown">
              <button
                className={`btn w-100 btn-${activeFilter.className} dropdown-toggle d-flex align-items-center justify-content-between gap-2`}
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>
                  <i className={`${activeFilter.icon} me-2`}></i>
                  {activeFilter.label}
                </span>
              </button>
              <ul className="dropdown-menu p-0 border border-primary w-100">
                {itemStatus.map((item) => (
                  <button
                    key={item.value}
                    onClick={() => setEstado(item.value)}
                    className={`w-100 btn btn-${
                      estado === item.value ? item.className : "outline-dark"
                    } rounded-0`}
                  >
                    <i className={`${item.icon} me-2`}></i>
                    {item.label}
                  </button>
                ))}
              </ul>
            </div>
          </div>
          {renderRevisionesDropdown()}
        </div>
      </div>
    </div>
  );
};

export default ChecklistHeader;
